import Navbar from "./Components/Navbar";
import Section1 from "./Components/Section1";
import Features from "./Components/Features";
import Card from "./Components/Card";
import Careers from "./Components/Careers";

function App() {
  return (
   
  <div>
    <Navbar/>
    <Section1/>
    <Features/>
    <Card/>
    <Careers/>
  </div>
  );
}

export default App;
